export default __webpack_public_path__ + "static/media/Arrowright.806946a2.svg";